import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, requireAdmin = true }) {
  const { user, checked } = useAuth();
  const location = useLocation();

  if (!checked) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <Loader2 size={22} className="text-[#C8A24B] animate-spin" />
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate
        to="/admin/login"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  if (requireAdmin && user.role !== "admin") {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}
